import styled from 'styled-components'

export const TooltipText = styled.div`
  font-size: ${(props) => props.theme.sizes.p};
  white-space: normal;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.neutralColor900};
  padding: 0.4rem;
  border-radius: 4px;
`

export const TooltipBox = styled.div<{ isClicked: boolean }>`
  display: ${(props) => (props.theme.isMobile && props.isClicked ? 'block' : 'none')};
  position: absolute;
  min-width: 14rem;
  white-space: normal;
  top: ${(props) => (props.theme.isMobile ? '1.5rem' : '-1.5rem')};
  margin-left: ${(props) => (props.theme.isMobile ? '-10rem' : '2rem')};
  text-align: center;
`

export const Wrapper = styled.div`
  position: relative;
  &:hover {
    cursor: pointer;
  }
  &:hover {
    > div:first-child {
      display: block;
    }
  }
`
